import { useAzureAuthScreenRedirect } from '@order/AzureAuth';

export const LoginScreen = () => {
  useAzureAuthScreenRedirect();

  return null;
};
